import React, { useEffect, useState } from 'react';
import { Star, ChevronLeft, ChevronRight } from 'lucide-react';
const TESTIMONIALS = [{
  name: 'Laura P.',
  location: 'Bogotá',
  text: 'Increíble cómo se me quitó la ansiedad de la tarde. Antes no podía pasar por una panadería sin entrar, ahora ni me provoca.',
  rating: 5,
  result: 'Sin antojos a las 4pm'
}, {
  name: 'Marcela R.',
  location: 'Medellín',
  text: 'Lo mejor es que no pasé hambre. Las recetas son deliciosas y fáciles de hacer con cosas del D1 o el Éxito.',
  rating: 5,
  result: '-3cm de cintura'
}, {
  name: 'Carolina M.',
  location: 'Cali',
  text: 'La neblina mental desapareció al tercer día. Me siento con una energía que no tenía hace años. Recomendadísimo.',
  rating: 5,
  result: 'Energía todo el día'
}, {
  name: 'Andrea S.',
  location: 'Barranquilla',
  text: 'Pensé que sería otra dieta más, pero es un cambio de chip total. El bono del café fue mi salvación.',
  rating: 4.5,
  result: 'Mejor digestión'
}, {
  name: 'Valentina T.',
  location: 'Pereira',
  text: 'Llevaba años luchando con el azúcar. Este método es el único que me ha funcionado sin sentir que estoy sufriendo.',
  rating: 5,
  result: 'Piel más limpia'
}, {
  name: 'Sofía L.',
  location: 'Bucaramanga',
  text: 'Me encanta que sea comida real colombiana. Nada de ingredientes raros o costosos. Muy fácil de seguir.',
  rating: 5,
  result: 'Ahorro en mercado'
}, {
  name: 'Daniela C.',
  location: 'Manizales',
  text: 'El kit de la oficina me salvó la vida. Mis compañeras comen postre todos los días y yo ya no siento la necesidad de unirme.',
  rating: 5,
  result: 'Control total'
}, {
  name: 'Juliana V.',
  location: 'Cartagena',
  text: 'Bajé la inflamación de mi estómago que no se iba con nada. Me siento mucho más ligera y mi ropa me queda mejor.',
  rating: 5,
  result: 'Cero inflamación'
}, {
  name: 'Camila G.',
  location: 'Bogotá',
  text: 'El radar de azúcar me abrió los ojos. Estaba comiendo cosas "saludables" que estaban llenas de azúcar escondida.',
  rating: 4.5,
  result: 'Compras inteligentes'
}, {
  name: 'Isabella M.',
  location: 'Envigado',
  text: 'Dormir bien otra vez no tiene precio. Antes me despertaba a las 3 am con hambre, ahora duermo de corrido.',
  rating: 5,
  result: 'Sueño profundo'
}, {
  name: 'Mariana P.',
  location: 'Santa Marta',
  text: 'Pensé que no iba a poder dejar mi tinto con panela, pero el ritual del tinto me enseñó a disfrutarlo de otra forma.',
  rating: 5,
  result: 'Nuevos hábitos'
}, {
  name: 'Natalia R.',
  location: 'Cúcuta',
  text: 'En 14 días logré lo que no pude en años de dietas restrictivas. Es un método súper realista y fácil de llevar.',
  rating: 5,
  result: 'Resultados rápidos'
}, {
  name: 'Gabriela H.',
  location: 'Armenia',
  text: 'Mi estado de ánimo mejoró muchísimo. Ya no tengo esos bajones horribles a media tarde donde me ponía de mal humor.',
  rating: 4.5,
  result: 'Estabilidad emocional'
}, {
  name: 'Valeria O.',
  location: 'Ibagué',
  text: 'Las recetas son súper prácticas para alguien que trabaja todo el día. No tienes que pasar horas en la cocina.',
  rating: 5,
  result: 'Ahorro de tiempo'
}, {
  name: 'Lucía F.',
  location: 'Villavicencio',
  text: 'El tracker diario me ayudó a mantenerme enfocada. Ver los chulitos cada día me motivaba a seguir adelante.',
  rating: 5,
  result: 'Mayor disciplina'
}, {
  name: 'Paula B.',
  location: 'Pasto',
  text: 'Definitivamente la mejor inversión que he hecho en mi salud. El precio es ridículo para todo el valor que entregan.',
  rating: 5,
  result: 'Excelente inversión'
}, {
  name: 'Catalina J.',
  location: 'Popayán',
  text: 'Me deshinche muchísimo en la primera semana. Es increíble ver cómo el cuerpo responde cuando le quitas el azúcar.',
  rating: 5,
  result: 'Desintoxicación'
}, {
  name: 'Sara N.',
  location: 'Neiva',
  text: 'Recomendado 100%. Mi esposo también lo hizo conmigo y los dos estamos felices con los resultados.',
  rating: 5,
  result: 'Cambio en pareja'
}];
export function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(1);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setItemsPerPage(3);
      } else {
        setItemsPerPage(1);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const nextSlide = () => {
    setCurrentIndex(prev => prev + itemsPerPage >= TESTIMONIALS.length ? 0 : prev + itemsPerPage);
  };
  const prevSlide = () => {
    setCurrentIndex(prev => prev - itemsPerPage < 0 ? Math.max(0, TESTIMONIALS.length - itemsPerPage) : prev - itemsPerPage);
  };
  const visibleTestimonials = TESTIMONIALS.slice(currentIndex, currentIndex + itemsPerPage);
  // Handle edge case for end of list
  const displayItems = visibleTestimonials.length < itemsPerPage ? [...visibleTestimonials, ...TESTIMONIALS.slice(0, itemsPerPage - visibleTestimonials.length)] : visibleTestimonials;
  return <section className="py-12 bg-gray-50 overflow-hidden" data-id="element-194">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-195">
        <div className="text-center mb-10" data-id="element-196">
          <h2 className="text-3xl font-bold text-secondary mb-2" data-id="element-197">
            Historias de Transformación
          </h2>
          <p className="text-gray-600" data-id="element-198">Mujeres reales, resultados reales</p>
        </div>

        <div className="relative max-w-6xl mx-auto" data-id="element-199">
          {/* Navigation Buttons */}
          <button onClick={prevSlide} className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 md:-translate-x-12 z-10 bg-white p-2 rounded-full shadow-md text-gray-600 hover:text-primary hover:scale-110 transition-all" aria-label="Previous testimonial" data-id="element-200">
            <ChevronLeft className="h-6 w-6" data-id="element-201" />
          </button>

          <button onClick={nextSlide} className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 md:translate-x-12 z-10 bg-white p-2 rounded-full shadow-md text-gray-600 hover:text-primary hover:scale-110 transition-all" aria-label="Next testimonial" data-id="element-202">
            <ChevronRight className="h-6 w-6" data-id="element-203" />
          </button>

          {/* Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-204">
            {displayItems.map((t, i) => <div key={`${currentIndex}-${i}`} className="bg-white p-6 rounded-xl shadow-md border border-gray-100 flex flex-col h-full animate-fade-in" data-id="element-205">
                <div className="flex items-center gap-3 mb-4" data-id="element-206">
                  <div className="w-10 h-10 rounded-full bg-gradient-to-br from-primary/20 to-primary/5 flex items-center justify-center text-primary font-bold text-sm" data-id="element-207">
                    {t.name.charAt(0)}
                  </div>
                  <div data-id="element-208">
                    <p className="font-bold text-gray-900 text-sm" data-id="element-209">{t.name}</p>
                    <p className="text-xs text-gray-500" data-id="element-210">{t.location}</p>
                  </div>
                  <div className="ml-auto flex" data-id="element-211">
                    {[...Array(5)].map((_, starI) => <Star key={starI} className={`h-4 w-4 ${starI < Math.floor(t.rating) ? 'text-accent-gold fill-current' : 'text-gray-300'}`} data-id="element-212" />)}
                  </div>
                </div>

                <div className="mb-4 flex-grow" data-id="element-213">
                  <p className="text-gray-600 text-sm italic leading-relaxed" data-id="element-214">
                    "{t.text}"
                  </p>
                </div>

                <div className="pt-4 border-t border-gray-100 mt-auto" data-id="element-215">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-50 text-green-700 border border-green-100" data-id="element-216">
                    {t.result}
                  </span>
                </div>
              </div>)}
          </div>

          {/* Dots Indicator */}
          <div className="flex justify-center gap-2 mt-8 flex-wrap max-w-xs mx-auto" data-id="element-217">
            {Array.from({
            length: Math.ceil(TESTIMONIALS.length / itemsPerPage)
          }).map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx * itemsPerPage)} className={`w-2 h-2 rounded-full transition-all ${Math.floor(currentIndex / itemsPerPage) === idx ? 'bg-primary w-6' : 'bg-gray-300 hover:bg-gray-400'}`} aria-label={`Go to slide ${idx + 1}`} data-id="element-218" />)}
          </div>
        </div>

        <div className="text-center mt-8" data-id="element-219">
          <p className="text-xs text-gray-400" data-id="element-220">
            Resultados pueden variar de persona a persona.
          </p>
        </div>
      </div>
    </section>;
}